import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'app/core/services/global/global.service';
import { LanguageService } from 'app/core/services/language/language.service';
@Component({
  selector: 'app-root',
  template: `<app-main-layuot><router-outlet></router-outlet></app-main-layuot>`
})
export class AppComponent implements OnInit {

  eventSapCode: string;
  lang: string;
  constructor(
      private _translate: TranslateService,
      private _global: GlobalService,
      private _language: LanguageService) {
      this._translate.setDefaultLang(`es_ES`);
  }

  ngOnInit() {
    this._translate.onLangChange.subscribe(event => {
      this._global.setHtmlLang(event.lang);
    });

    if (!this._global.manualLangSelected) {
      const urlLang = this.getLangFromUrl();
      this._global.lang = this._language.resolveInternalLang(urlLang);
      this._translate.use(this._global.lang);
      this._global.langAppliedFromUrl = !!urlLang;
    }
  }

  private getLangFromUrl(): string | null {
    return new URLSearchParams(window.location.search).get('lang');
  }
}
